const FooterSection = () => {
    return(
        <footer className="footer">
            <div className="container">

            </div>
        </footer>
    )
}

export default FooterSection